export const SmsFormTypes = Object.freeze({
    "custom_email": "custom_email",
    "email": "internal_email",
    "sms": "customer_sms",
    "normal": "Normal",
    "certificado": "Certificado",
    "email_customer": "external_email",
    "default": null
})

export const SmsFormTypeIds = Object.freeze({
    "custom_email": 1,
    "internal_email": 2,
    "external_email": 3,
    "sms": 4
})